import HeroSection from './sections/HeroSection';
import InfoBarSection from './sections/InfoBarSection';
import TopFeaturesSection from './sections/TopFeaturesSection';
import ContactUsSection from './sections/ContactUsSection';

const Home = () => {
  return (
    <>
      <HeroSection />
        <InfoBarSection />
        <TopFeaturesSection />
        <ContactUsSection />
    </>
  );
};

export default Home; 